// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1MYf8","colCheckbox":"styles_colCheckbox__1uwFU"};